var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NoticeListBox"},[_c('ul',{staticClass:"noticeList",style:({top:_vm.top+'px',transition:("top " + _vm.animateTime + "s")})},[_vm._l((_vm.notices),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.notices[0]))])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d70b2e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoticeList.vue
// module id = null
// module chunks = 